// @flow
import type { State } from "@store/reducers";
import type {
  CallbackQueuesItem,
  ActiveCallbacksFilters,
  ActiveCallbackItem,
  CompletedCallbacksFilters,
} from "@modules/management/types";
import { getPagination } from "@selectors";
import type { PaginationExtendedType } from "@types";

export const callbackQueues = (state: State): CallbackQueuesItem[] =>
  (state.management.callbackQueues || {}).content || [];

export const activeCallbacks = (state: State): ActiveCallbackItem[] =>
  (state.management.activeCallbacks || {}).content || [];

export const completedCallbacks = (state: State): ActiveCallbackItem[] =>
  (state.management.completedCallbacks || {}).content || [];

export const selectActiveCallbacksPagination = (state: State): PaginationExtendedType =>
  getPagination(state.management.activeCallbacks);

export const selectActiveCallbacksPage = (state: State): number | null =>
  selectActiveCallbacksPagination(state).pageNumber;

export const selectCompletedCallbacksPagination = (state: State): PaginationExtendedType =>
  getPagination(state.management.completedCallbacks);

export const selectCompletedCallbacksPage = (state: State): number | null =>
  selectCompletedCallbacksPagination(state).pageNumber;

export const selectActiveCallbacksFilters = (state: State): ActiveCallbacksFilters =>
  (state.form["active-callbacks-filters"] || {}).values || {};

export const selectCompletedCallbacksFilters = (state: State): CompletedCallbacksFilters | Object =>
  (state.form["completed-callbacks-filters"] || {}).values || {};

export const isRemoveCallbackModalVisible = (state: State): boolean =>
  state.management.modals.removeCallback.visible;

export const isRescheduleCallbackModalVisible = (state: State): boolean =>
  state.management.modals.rescheduleCallback.visible;

export const isCreateCallbackModalVisible = (state: State): boolean =>
  state.management.modals.createCallback.visible;
